import { computed, ref, watch } from 'vue';
import type { ConditionOperatorProps } from './ConditionOperator.vue';
import RailsUtility from '@/utilities/rails';
import { useInjectedConditionEditor } from './useWorkflowConditionEditorProvider';

export const useConditionOperator = (props: ConditionOperatorProps) => {
  const localOperatorPretty = computed(() => RailsUtility.convertFromEnumFormat(props.expressionCondition.operator));
  const selectedOperatorString = ref<string>(localOperatorPretty.value);
  const conditionEditor = useInjectedConditionEditor();

  const currentOptions = computed(() =>
    props.conditionDefinition.operators.map(op => RailsUtility.convertFromEnumFormat(op.type))
  );

  const currentOperatorDefinition = computed(
    () =>
      props.conditionDefinition.operators.find(
        op => RailsUtility.convertFromEnumFormat(op.type) == selectedOperatorString.value
      )!
  );

  const onOperatorChange = () => {
    conditionEditor.changeCondition({ index: props.index, operator: currentOperatorDefinition.value.type });
  };

  const onPropertyOptionChange = () => {
    selectedOperatorString.value = RailsUtility.convertFromEnumFormat(props.conditionDefinition.operators[0].type);
  };

  watch(
    () => props.selectedProperty,
    () => {
      onPropertyOptionChange();
    }
  );

  watch(
    () => localOperatorPretty.value,
    operator => (selectedOperatorString.value = operator)
  );

  return {
    selectedOperatorString,
    currentOptions,
    currentOperatorDefinition,
    onOperatorChange,
    onPropertyOptionChange,
  };
};
